"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8285],{

/***/ 88285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ fade_in_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-component.scss.js



var StyledFadeInAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eloyjbp0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;position:relative;.background-asset-container{z-index:", z_index/* LAYER_ONE */.KW, ";position:relative;width:100%;}.fade-in-asset-container{position:absolute;top:", function(param) {
    var startingPosition = param.startingPosition;
    return startingPosition;
}, ";left:50%;transform:translateX(-50%);height:", function(param) {
    var fadeInAssetHeight = param.fadeInAssetHeight;
    return fadeInAssetHeight;
}, ";z-index:", z_index/* HIDDEN */.A1, ";opacity:0;img{height:", function(param) {
    var fadeInAssetHeight = param.fadeInAssetHeight;
    return fadeInAssetHeight;
}, ";}&.visible{animation:fadeIn ease-in-out forwards;z-index:", z_index/* LAYER_TWO */.wc, ";animation-duration:", function(param) {
    var animationDuration = param.animationDuration;
    return animationDuration;
}, "s;}@keyframes fadeIn{from{opacity:0;top:", function(param) {
    var startingPosition = param.startingPosition;
    return startingPosition;
}, ";}to{opacity:1;top:0;}}");

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var FadeInAssetComponent = function(param) {
    var backgroundAsset = param.backgroundAsset, fadeInAsset = param.fadeInAsset, isInView = param.isInView, startingPosition = param.startingPosition, animationDuration = param.animationDuration, advancedAssetConfig = param.advancedAssetConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFadeInAssetComponent, {
        className: "fade-in-asset-component",
        startingPosition: startingPosition,
        animationDuration: animationDuration,
        fadeInAssetHeight: fadeInAsset === null || fadeInAsset === void 0 ? void 0 : fadeInAsset.height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-asset-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, backgroundAsset, advancedAssetConfig))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("fade-in-asset-container", {
                    visible: isInView
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, fadeInAsset, advancedAssetConfig))
            })
        ]
    });
};
/* harmony default export */ var fade_in_asset_component = (FadeInAssetComponent);


/***/ })

}]);